import * as React from "react"
import { IconButton, CardHeader, Tooltip } from "@material-ui/core"
import {
  Edit,
  Slash,
  CheckCircleIcon,
  ExpandMoreIcon,
  ExpandLessIcon,
} from "@iconsGallery"
import _ from "lodash"
import { View } from "./View"
import * as Features from "@features"
import * as Utils from "@utils"
import * as QA_Automation from "@qaAutomation"

export const customRenderContainer = (props) => {
  const { facetData, isEditMode, edit, setAllowPrompt = () => {} } = props
  return Utils.JSUtils.isEmpty(facetData) ? (
    isEditMode && !edit ? (
      <View {...props} setAllowPrompt={setAllowPrompt} />
    ) : (
      <Features.NoRecordFound />
    )
  ) : (
    <View {...props} setAllowPrompt={setAllowPrompt} />
  )
}
  let testIDKit = QA_Automation?.doAddOnTestIdCommonFacetUIKit


export const customRenderHeader = (props) => {
  const { classes, setEdit, expanded, handleExpandClick, updateData, setAllowPrompt = () => "", resetData = () => "", isEditMode = true,
    label = "", isAnyChange, setAnyChange, isWriteAllowed, t,testIdLabel=""
  } = props || {}
  return (
    <CardHeader
    {...testIDKit(`${testIdLabel}-accordian-header`)}
      style={{ borderBottom: '1px solid #EEEEEE', cursor: "pointer" }}
      className={expanded === false ? classes.dividerBottom : ""}
      title={<div style={{ fontWeight: "bold" }}>{t(label)}</div>}
      onClick={() => {
        setEdit(true)
        resetData()
        handleExpandClick()
        setAllowPrompt(false)
      }}
      action={
        <>
          {props.edit ? (
            <>
              {expanded === true && isEditMode === true && (
                <Tooltip title={t("EDIT")} placement="top">
                  <IconButton
                   {...testIDKit(`${testIdLabel}-edit-icon`)}
                    onClick={(e) => {
                      e.stopPropagation()
                      setEdit(false)
                      setAllowPrompt(true)
                    }}
                    style={{ marginRight: "13px" }}
                    disabled={isWriteAllowed ? false : true}
                  >
                    <Edit className={classes.basicIconProperty} />
                  </IconButton>
                </Tooltip>
              )}
            </>
          ) : (
            <>
              {expanded === true ? (
                <>
                  <Tooltip title={t("CLOSE")} placement="top">
                    <IconButton
                      {...testIDKit(`${testIdLabel}-slash-icon`)}
                      onClick={(e) => {
                        e.stopPropagation()
                        resetData()
                        setAllowPrompt(false)
                        setAnyChange(false)
                        setEdit(true)
                      }}
                      style={{ marginRight: "20px" }}
                    >
                      <Slash
                        style={{ color: "red" }}
                        className={classes.basicIconProperty}
                      />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={t("SAVE")} placement="top">
                    <IconButton
                      {...testIDKit(`${testIdLabel}-check-circle-icon`)}
                      style={{
                        marginRight: "18px",
                        pointerEvents: `${isAnyChange ? "unset" : "none"}`,
                      }}
                      onClick={(e) => {
                        e.stopPropagation()
                        updateData(props)
                        setEdit(true)
                        setAnyChange(false)
                      }}
                    >
                      <CheckCircleIcon
                        style={{ color: `${isAnyChange ? "#4CAF50" : "#CCC"}` }}
                      />
                    </IconButton>
                  </Tooltip>
                </>
              ) : (
                ""
              )}
            </>
          )}
          {expanded === true ? (
            <IconButton {...testIDKit(`${testIdLabel}-expand-less-icon`)}>
              <ExpandLessIcon className={classes.iconUpDown} />
            </IconButton>
          ) : (
            <IconButton {...testIDKit(`${testIdLabel}-expand-more-icon`)}>
              <ExpandMoreIcon className={classes.iconUpDown} />
            </IconButton>
          )}
        </>
      }
    ></CardHeader>
  )
}
